import { XxsSpacing } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { FlexColumn, FlexRow, Link, spacing } from '@alto/pocky';
import React from 'react';
// eslint-disable-next-line import/no-deprecated
import { deleteInsurance, selectInsurance } from '~shared/actions/insurances';
import { openModal } from '~shared/actions/modal';
import { getDeliveries } from '~shared/features/delivery/selectors/getDeliveries';
import getIsPhotoUpload from '~shared/features/insurances/helpers/getIsPhotoUpload';
import { useAnalytics } from '~shared/hooks/useAnalytics';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { getDeliveriesBilledWithInsuranceCount } from '~shared/lib/analytics/src/getDeliveriesBilledWithInsuranceCount';
import getInsuranceSource from '~shared/lib/analytics/src/getInsuranceSource';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { type Insurance as InsuranceType } from '~shared/types';
import { ConfirmLink } from '~web/components/legacy';
import InsuranceCard from '~web/features/onboarding/components/redesign/InsuranceCard';

type Props = {
  readonly hideActions?: boolean;
  readonly insurance: InsuranceType;
};

export const Insurance = ({ hideActions = false, insurance }: Props) => {
  const dispatch = useDispatchShared();
  const { trackEvent } = useAnalytics();
  const deliveries = useSelectorShared(getDeliveries);
  const source = useSelectorShared(getInsuranceSource);

  const handleEditInsurance = () => {
    dispatch(selectInsurance(insurance));
    dispatch(openModal('INSURANCE_MODAL'));
  };

  const handleDeleteInsurance = async () => {
    // eslint-disable-next-line import/no-deprecated
    const success = await dispatch(deleteInsurance(insurance));

    if (success) {
      const billedDeliveriesCount = getDeliveriesBilledWithInsuranceCount(deliveries, insurance.id);
      trackEvent({
        event: EVENTS.INSURANCE_REMOVED,
        params: {
          source,
          'insurance source': insurance.source,
          'num deliveries billed with insurance': billedDeliveriesCount,
        },
      });
    }
  };

  const insuranceStillProcessing = getIsPhotoUpload(insurance);

  return (
    <FlexRow spacing={spacing.xxsSpacing}>
      <InsuranceCard insurance={insurance} />
      <XxsSpacing key="edit insurance spacing" />
      {!hideActions && (
        <FlexColumn
          verticallyAlignContent
          rightAlignContent
        >
          {!insuranceStillProcessing && (
            <>
              <Link
                small
                onClick={handleEditInsurance}
              >
                Edit
              </Link>
              <span>&nbsp;|&nbsp;</span>
            </>
          )}
          <ConfirmLink
            confirmPrompt="Are you sure you want to delete this?"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleDeleteInsurance}
          >
            Delete
          </ConfirmLink>
        </FlexColumn>
      )}
    </FlexRow>
  );
};
